import { AdminOnlyItemRestraints } from '@core/shared/restraints';
export class CompanyDemoRestraints extends AdminOnlyItemRestraints {
  canViewItem(item) {
    return true;
  }
}